import React from 'react';
import {ThemedView, ThemedText} from "@app/theme";
import CreditLimit from "../../../../assets/Icons/CreditLimit";
import EditIcon from "../../../../assets/Icons/EditIcon";
import {TouchableOpacity} from "react-native";
import {addCommasToNumber} from "@app/utils";

interface CreditLimitCardProps {
  showEditLimit: boolean;
  onEditPress: () => void;
  creditLimit: number;
  isFromEnhanceLimit?: boolean;
}

const CreditLimitCard: React.FC<CreditLimitCardProps> = ({isFromEnhanceLimit,showEditLimit, onEditPress, creditLimit}) => (
    <ThemedView borderWidth={1} borderColor={"border-primary"} mt={"md"} borderRadius={"lg"} style={{
      shadowColor: "#98A2B3",
      backgroundColor: 'white',
      shadowOffset: {
        width: 0,
        height: 1,
      },
      shadowRadius: 20,
      shadowOpacity: 0.2,
    }}
                paddingVertical={"lg"} paddingHorizontal={"xl"}>
        <ThemedView flexDirection={"row"}>
            <ThemedView flexDirection={"row"}>
                <CreditLimit color={'red'}/>
                <ThemedView ml={"md"}>
                    <ThemedText variant={"b3r"} color={"text-secondary"}>
                        {isFromEnhanceLimit ? "Eligible credit limit" : "Credit limit"}
                    </ThemedText>
                    <ThemedView flexDirection={"row"}>
                        <ThemedView flexDirection={"row"}>
                            <ThemedText variant={"h2b"} fontFamily='Inter' color={"text-primary"}>
                                ₹
                            </ThemedText>
                            <ThemedText variant={"h2b"} color={"text-primary"}>
                                {`${addCommasToNumber(creditLimit)}`}
                            </ThemedText>
                        </ThemedView>
                        <ThemedView alignItems={"flex-end"} ml={"xs"} alignSelf={"flex-end"} mb={"2xs"}>
                            {showEditLimit && (
                                <TouchableOpacity hitSlop={{left : 10 , right : 10 , top : 10 , bottom :10}} activeOpacity={1} onPress={onEditPress}>
                                    <EditIcon />
                                </TouchableOpacity>
                            )}
                        </ThemedView>
                    </ThemedView>
                </ThemedView>
            </ThemedView>
          
        </ThemedView>
    </ThemedView>
);

export default CreditLimitCard;